import { titleize } from 'util/strings';
import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { Switch } from 'react-router';
import Route from 'components/Route';
import H1 from 'components/deprecated/legacyElements/H1';
import H2 from 'components/deprecated/legacyElements/H2';
import BuildingListPage from './BuildingListPage';
import CityNeighborhoodListPage from './CityNeighborhoodListPage';
import styles from './style.module.scss';

export default class SitemapPage extends PureComponent {
  render() {
    const { state, city, neighborhood, page } = this.props.match.params;

    let title = 'Commercial Buildings For Rent';
    if (city) {
      if (neighborhood) {
        title = `${titleize(neighborhood)}, ${titleize(city)} ${title}`;
      } else {
        title = `${titleize(city)}, ${(state || '').toUpperCase()} ${title}`;
      }
    }
    if (page && parseInt(page, 10) > 1) {
      title += `, Page ${page}`;
    }

    return (
      <div className={`inset ${styles.container}`}>
        <Helmet title={title} />
        <H1 inset>{title}</H1>
        {city && (
          <H2>
            <Link to="/buildings/">&larr; All Commercial Buildings</Link>
          </H2>
        )}
        <Switch>
          <Route
            path="/buildings/:state([A-Za-z]{2})/:city/:neighborhood(\D[^\/]+)?/:page(\d+)?"
            loader={BuildingListPage}
          />
          <Route exact path="/buildings/" loader={CityNeighborhoodListPage} />
        </Switch>
      </div>
    );
  }
}
